import PropTypes from 'prop-types';

export const BookingIntroTitle = ({ price, isGift }) => (
  <div>
    {isGift
      ? 'We will contact you to arrange payment of '
      : 'A Beauty Therapist will take payment of '}
    <strong>{` ${price}`}</strong>
    {isGift || ' at the appointment'}.
  </div>
);

BookingIntroTitle.propTypes = {
  price: PropTypes.string.isRequired,
  isGift: PropTypes.bool.isRequired,
};
